import React from 'react';
import {
  Box,
  VStack,
  Heading,
  Text,
  Button,
  Container,
  useColorModeValue
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

export const NotFound = ({ message = "Page not found", subMessage = "The page you're looking for doesn't exist." }) => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const textColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Container maxW="lg" py={20}>
      <VStack spacing={8} textAlign="center">
        <Box>
          <Heading
            size="4xl"
            bgGradient="linear(to-r, blue.400, purple.500)"
            bgClip="text"
            fontWeight="bold"
          >
            404
          </Heading>
        </Box>

        <VStack spacing={4}>
          <Heading size="lg" color={textColor}>
            {message}
          </Heading>
          <Text fontSize="lg" color={textColor} maxW="md">
            {subMessage}
          </Text>
        </VStack>

        <VStack spacing={4}>
          <Button
            colorScheme="blue"
            size="lg"
            onClick={() => navigate('/')}
          >
            Go Home
          </Button>
          <Button
            variant="ghost"
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>
        </VStack>
      </VStack>
    </Container>
  );
};
